import InterviewHistoryListDisplayVO from '@domain/vo/pass/interview/history/InterviewHistoryListVO';
import classNames from 'classnames/bind';
import React from 'react';
import { HistoryCard } from './card';
import { DateLine } from './dateLine';
import { InterviewPracticeHistoryListEmpty } from './empty';
import styles from './historyList.module.scss';

const cx = classNames.bind(styles);

interface Props {
  openModal: (id: number) => void;
  historyListData: InterviewHistoryListDisplayVO;
}

const InterviewPracticeHistoryList = ({ openModal, historyListData }: Props) => {
  return (
    <div className={cx('interviewPracticeHistoryList')}>
      <div className={cx('title')}>연습기록 리스트</div>
      {historyListData.list.length === 0 && <InterviewPracticeHistoryListEmpty />}
      <div className={cx('listContainer')}>
        {historyListData.list.map(({ cards, displayDate }, index) => (
          <React.Fragment key={index}>
            <DateLine displayDate={displayDate} />
            <div className={cx('cardList')}>
              {cards.map((card) => (
                <HistoryCard data={card} openModal={openModal} key={card.id} />
              ))}
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default InterviewPracticeHistoryList;
